"use client";

import { useState } from "react";
import { useSelector } from "react-redux";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";
import ICON_CORNER from "@/assets/images/icon-corner.svg";

const GRID_COLUMNS_HALF1 = "75px 55px 40px 1.2fr 2fr 60px";
const GRID_COLUMNS_FULL = "75px 55px 40px 1.2fr 1.8fr 1.8fr 60px";

export default function KeoOddsMatchLeagues({ league, matches, banner, render = () => { }, isFirst }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const oddsPeriod = useSelector((state) => state.oddsPeriodReducer) || "full";
  const isHalf1 = oddsPeriod === "half1";

  return (
    <div className="flex flex-col w-full bg-[var(--theme-foreground)] !mt-0">
      {/* Header chỉ xuất hiện ở giải đấu đầu tiên */}
      {isFirst && (
        <div
          className="kbv-table-head hidden md:grid w-full border-t border-b [border-top-style:solid] [border-bottom-style:solid] border-[var(--theme-border)] font-semibold uppercase min-h-[44px] rounded-t-lg"
          style={{ gridTemplateColumns: isHalf1 ? GRID_COLUMNS_HALF1 : GRID_COLUMNS_FULL }}
        >
          <div className="flex items-center justify-center border-r [border-right-style:solid] border-[var(--theme-border)] h-full">THỜI GIAN</div>
          <div className="flex items-center justify-center border-r [border-right-style:solid] border-[var(--theme-border)] h-full">TỈ SỐ</div>
          <div className="flex items-center justify-center border-r [border-right-style:solid] border-[var(--theme-border)] h-full">
            <img src={ICON_CORNER} alt="corner" className="w-[14px] h-[14px]" />
          </div>
          <div className="flex items-center justify-start px-2 py-1 border-r [border-right-style:solid] border-[var(--theme-border)] h-full">ĐỘI BÓNG</div>
          {/* Hiệp 1 */}
          <div className="flex flex-col border-r [border-right-style:solid] border-[var(--theme-border)] h-full">
            <div className="kbv-table-subhead flex items-center justify-center py-0.5 border-b [border-bottom-style:solid] border-[var(--theme-border)] text-[11px]">HIỆP 1</div>
            <div className="flex-1 items-center grid grid-cols-3 h-full">
              <div className="flex items-center justify-center text-[11px] border-r [border-right-style:solid] border-[var(--theme-border)] h-full px-1 text-center">CƯỢC CHẤP</div>
              <div className="flex items-center justify-center text-[11px] border-r [border-right-style:solid] border-[var(--theme-border)] h-full px-1 text-center">TÀI/XỈU</div>
              <div className="flex items-center justify-center text-[11px] h-full px-1 text-center">1×2</div>
            </div>
          </div>
          {/* Toàn trận - ẩn khi chọn Hiệp 1 */}
          {!isHalf1 && (
            <div className="flex flex-col border-r [border-right-style:solid] border-[var(--theme-border)] h-full">
              <div className="kbv-table-subhead flex items-center justify-center py-0.5 border-b [border-bottom-style:solid] border-[var(--theme-border)] text-[11px]">TOÀN TRẬN</div>
              <div className="flex-1 items-center grid grid-cols-3 h-full">
                <div className="flex items-center justify-center text-[11px] border-r [border-right-style:solid] border-[var(--theme-border)] h-full px-1 text-center">CƯỢC CHẤP</div>
                <div className="flex items-center justify-center text-[11px] border-r [border-right-style:solid] border-[var(--theme-border)] h-full px-1 text-center">TÀI/XỈU</div>
                <div className="flex items-center justify-center text-[11px] h-full px-1 text-center">1×2</div>
              </div>
            </div>
          )}
          <div className="flex items-center justify-center h-full">THÊM</div>
        </div>
      )}

      <div
        className="kbv-league-head flex items-center gap-2.5 px-2.5 py-1.5 cursor-pointer select-none border-b border-[var(--theme-border)] rounded-t-lg md:h-30px]"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {league.logo && (
          <img src={league.logo} alt="" className="w-[24px] h-[24px] object-contain shrink-0" loading="lazy" />
        )}
        <span className="text-xs font-bold uppercase flex-1 truncate">{league.name}</span>
        <span className="text-red-600 text-xs font-bold shrink-0">
          {matches?.length || 0} trận đấu
        </span>
        <img
          src={ICON_ARROW_UP}
          alt=""
          className={`w-[14px] h-[14px] transition-transform brightness-0 invert ${isExpanded ? "" : "rotate-180"}`}
        />
      </div>

      {isExpanded && (
        <>
          {/* Match */}
          <div className="flex flex-col w-full">
            {matches.map((match, index) => (
              <div key={match.id}>
                {render(match, index)}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
